import { Application } from "stimulus";
import Dropdown from "@stimulus-components/dropdown";
import ScrollTo from "@stimulus-components/scroll-to";
import Order from "./controllers/order_controller";

const application = Application.start();
application.register("dropdown", Dropdown);
application.register("scroll-to", ScrollTo);
application.register("order", Order);

export default application;
